module.exports = __webpack_public_path__ + "static/media/480.d7c077ad.png";


//////////////////
// WEBPACK FOOTER
// ./src/img/services/img/i8-spring/light/480.png
// module id = 2466
// module chunks = 2